// Generated by @nuxtjs/svg-sprite
export const sprites = {
  "icons": () => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/assets/sprite/gen/icons.svg").then(r => r.default || r)
}
export const spriteClass = "";

export const spriteClassPrefix = "";

export const defaultSprite = "icons";
